import gql from 'graphql-tag';

const contractPortalUserFields = `
  userLoginId
  usersId
  name
  username
  emailAddress
  link
  isLinked
`;

export const getContractLevelUsersQuery = gql`
  query GetContractLevelUsers($contractNumber: String!, $azureUserId: String) {
    getContractLevelUsers(contractNumber: $contractNumber, azureUserId: $azureUserId) {
      ${contractPortalUserFields}
    }
  }
`;

export const searchContractPortalUsersQuery = gql`
  query SearchContractPortalUsers($contractNumber: String!, $email: String!, $azureUserId: String) {
    searchContractPortalUsers(contractNumber: $contractNumber, email: $email, azureUserId: $azureUserId) {
      ${contractPortalUserFields}
    }
  }
`;

export const updateContractPortalUserLinkStatusMutation = gql`
  mutation UpdateContractPortalUserLinkStatus(
    $contractNumber: String!
    $userLoginId: Int!
    $link: Boolean!
    $azureUserId: String
  ) {
    updateContractPortalUserLinkStatus(
      contractNumber: $contractNumber
      userLoginId: $userLoginId
      link: $link
      azureUserId: $azureUserId
    ) {
      message
      alreadyLinked
      alreadyUnlinked
    }
  }
`;
